import React, { lazy } from 'react';
import { RouteConfig } from '../model/route';
// Lazy load all page components
const ErrorPage = lazy(() => import('../pages/ErrorPage'));
const Conditions = lazy(() => import('../pages/Conditions'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const Contact = lazy(() => import('../pages/Contact'));
const Imprint = lazy(() => import('../pages/Imprint'));
const Privacy = lazy(() => import('../pages/Privacy'));
const MarkdownContentPage = lazy(() => import('../pages/MarkdownContentPage'));
const Team = lazy(() => import('../pages/Team'));
const Stream = lazy(() => import('../pages/Stream'));
const EventDetailPage = lazy(() => import('../pages/EventDetailPage'));
const MainLandingPage = lazy(() => import('../pages/MainLandingPage'));
const UserSettings = lazy(() => import('../pages/UserSettings'));
const Gallery = lazy(() => import('../pages/Gallery'));
const GalleryDetail = lazy(() => import('../pages/GalleryDetail'));
const BecomeMember = lazy(() => import('../pages/BecomeMember'));
const AdminDashboard = lazy(() => import('../pages/admin/AdminDashboard'));
const UserManagement = lazy(() => import('../pages/admin/UserManagement'));
const SystemSettings = lazy(() => import('../pages/admin/SystemSettings'));
const DataManagement = lazy(() => import('../pages/admin/DataManagement'));
const UserClaimsPage = lazy(() => import('../pages/UserClaimsPage'));
const UserSalesPage = lazy(() => import('../pages/sale/UserSalesPage'));
const ClubActions = lazy(() => import('../pages/ClubActions'));
const ClubActionDetail = lazy(() => import('../pages/ClubActionDetail'));
const StockOverview = lazy(() => import('../pages/sale/StockOverview'));
const StockControl = lazy(() => import('../pages/sale/StockControl'));
const CounterLogin = lazy(() => import('../pages/sale/CounterLogin'));
const StockCustomerSale = lazy(() => import('../pages/sale/StockCustomerSale'));
const OrderConfirmation = lazy(() => import('../pages/sale/OrderConfirmation'));

export const routesConfig: RouteConfig[] = [
  {
    label: 'Home',
    path: '/',
    element: <MainLandingPage />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'About us',
    path: '/about-us',
    element: <MarkdownContentPage url="about-us" />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Team',
    path: '/team',
    element: <Team />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Vereinsaktionen',
    path: '/club-actions',
    element: <ClubActions />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Vereinsaktionen',
    path: '/club-action/:url',
    element: <ClubActionDetail />,
    roles: [],
    disabledMenu: true,
    isSecure: false,
  },
  {
    label: 'Stream',
    path: '/stream',
    element: <Stream />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Galerie',
    path: '/gallery',
    element: <Gallery />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Galerie Detail',
    path: '/gallery/:galleryUrl',
    element: <GalleryDetail />,
    roles: [],
    isSecure: false,
    disabledMenu: true,
  },
  {
    label: 'Mitglied werden',
    path: '/become-member',
    element: <BecomeMember />,
    roles: [],
    disabledMenu: true,
    isSecure: false,
  },
  {
    label: 'Fehler',
    path: '/error',
    element: <ErrorPage />,
    disabledMenu: true,
    roles: [],
    isSecure: false,
  },
  {
    label: 'AGB',
    path: '/conditions',
    disabledMenu: true,
    element: <Conditions />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Über Uns',
    path: '/about',
    disabledMenu: true,
    element: <AboutUs />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Kontakt',
    path: '/contact',
    disabledMenu: true,
    element: <Contact />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Impressum',
    path: '/imprint',
    disabledMenu: true,
    element: <Imprint />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Datenschutz',
    path: '/privacy',
    disabledMenu: true,
    element: <Privacy />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Markdown Inhalte',
    path: '/content/:url',
    disabledMenu: true,
    element: <MarkdownContentPage />,
    roles: [],
    isSecure: false,
  },
  {
    label: 'Events',
    path: '/event/:url',
    element: <EventDetailPage />,
    roles: [],
    isSecure: false,
    disabledMenu: true,
  },
  {
    label: 'Benutzereinstellungen',
    path: '/user-settings',
    element: <UserSettings />,
    roles: ['USER'],
    isSecure: true,
    disabledMenu: true,
  },
  {
    label: 'Benutzerinformationen',
    path: '/user-claims',
    element: <UserClaimsPage />,
    roles: ['USER'],
    isSecure: true,
    disabledMenu: true,
  },
  {
    label: 'Bestellungen',
    path: '/user-sales',
    element: <UserSalesPage />,
    roles: ['USER'],
    isSecure: true,
    disabledMenu: true,
  },
  {
    label: 'POS',
    path: '/pos',
    element: <StockOverview />,
    roles: ['USER'],
    disabledMenu: true,
    isSecure: true,
    children: [
      {
        label: 'Thekenanmeldung',
        path: '/pos/counter-login',
        element: <CounterLogin />,
        roles: ['MEMBER'],
        disabledMenu: true,
        isSecure: true,
      },
      {
        label: 'Bestellung',
        path: '/pos/stock/:stockId',
        element: <StockControl />,
        roles: ['MEMBER'],
        isSecure: true,
        disabledMenu: true,
      },
      {
        label: 'Bestellung',
        path: '/pos/stock/:stockId/:accountId',
        element: <StockCustomerSale />,
        roles: ['MEMBER'],
        isSecure: true,
        disabledMenu: true,
      },
      {
        label: 'Bestellbestätigung',
        path: '/pos/order/:publicId',
        element: <OrderConfirmation />,
        roles: [],
        isSecure: false,
        disabledMenu: true,
      },
    ],
  },
  {
    label: 'Admin',
    path: '/admin',
    element: <AdminDashboard />,
    roles: ['admin'],
    isSecure: true,
    children: [
      {
        label: 'Dashboard',
        path: '/admin',
        element: <AdminDashboard />,
        roles: ['admin'],
        isSecure: true,
      },
      {
        label: 'Benutzerverwaltung',
        path: '/admin/users',
        element: <UserManagement />,
        roles: ['admin'],
        isSecure: true,
      },
      {
        label: 'Systemeinstellungen',
        path: '/admin/settings',
        element: <SystemSettings />,
        roles: ['admin'],
        isSecure: true,
      },
      {
        label: 'Datenverwaltung',
        path: '/admin/data',
        element: <DataManagement />,
        roles: ['admin'],
        isSecure: true,
      },
    ],
  },
];
